<template lang="pug">
.report-list-view
    h2.section-title.pb-1 {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.title') }}
    el-card
        div.table-report-list
            el-table(:data='selectedContracts', :default-sort={ prop: 'contractNumber', order: 'descending' }, :empty-text="$t('mensagens.operacao.tabela.vazia')" highlight-current-row="", v-loading='carregandoTabela', ref='tableReport')
                el-table-column(min-width="120px" prop="contractNumber" :label="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.contractNumber')")
                    template(slot-scope='scope')
                        p {{ scope.row.contractNumber }}
                el-table-column(align="right" prop="contractVolume" :label="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.availableVolume')")
                    template(slot-scope='scope')
                        p {{ formatters.formatNumber(scope.row.avaliableVolume) }}
                el-table-column(align="right" prop="contractVolume" :label="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.addedVolume')")
                    template(slot-scope='scope')
                        p {{ formatters.formatNumber(scope.row.reportAddedVolume || scope.row.volumeSelecionado) }}
                el-table-column(min-width="120px" prop="contractDate" :label="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.contractDate')")
                    template(slot-scope='scope')
                        p {{ formatData(scope.row.contractDate) }}
                el-table-column(:label="$t('mensagens.blocoFiltros.uteis.municipio')", sortable)
                    template(slot-scope='scope')
                        span {{ scope.row.receivingLocation }}
                el-table-column(:label="$t('mensagens.comuns.acoes')" align="center")
                    template(v-slot="scope").action-buttons
                        BaseButton(type="text", icon="el-icon-view", @click="verContrato(scope.row)")

            div.table-relatorio-rastreabilidade__pagination
                div.total
                    span
                    | {{ paginacao.totalElements }} {{ $tc('mensagens.relatorioRastreabilidade.tabelaListagem.resultados', paginacao.totalElements) }}
                    div(style="margin: 0 20px")
                    span
                    | {{ $t('mensagens.relatorioRastreabilidade.tabelaListagem.visualizacaoPorPagina') }}:
                    el-pagination(:current-page="paginacao.page" @size-change="handleSizeChange" :page-sizes="[10, 20, 30, 40]" :page-size="paginacao.size" layout="sizes" :total="paginacao.totalElements")
                div.prev_next
                    el-pagination(:current-page="paginacao.page" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]" :page-size="paginacao.size" layout="prev, pager, next, jumper" :total="paginacao.totalElements")

    ModalViewContract(
       :mostrar="mostrar",
       :contractId="contractId",
       @fechar="fecharModalViewContract"
    )
</template>
<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';
import ModalViewContract from '@/modules/traceability-report/views/components/modal-view-contract/ModalViewContract.vue';
import formatters from '@/utils/formatters';

export default {
    name: 'ReportListViewDefault',
    components: {
        BaseButton,
        ModalViewContract
    },
    data() {
        return {
            formatters,
            idRelatorio: null,
            selectedContracts: [],
            carregandoTabela: false,
            paginacao: {
                size: 20,
                page: 0,
                totalPages: 0,
                totalElements: 0
            },
            contractId: null,
            mostrar: false
        };
    },
    async mounted() {
        const params = this.$route.params;
        this.idRelatorio = params.id;
        await this.fetchContracts(this.paginacao.page);
    },
    methods: {
        formatadorDeTexto(texto) {
                return texto
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\s+/g, '-')
                .toUpperCase();
        },
        
        handleSizeChange(size) {
            this.paginacao.size = size;
            this.fetchContracts(this.paginacao.page - 1);
        },

        handleCurrentChange(page) {
            this.paginacao.page = page - 1;
            this.fetchContracts(this.paginacao.page);
        },

        async fetchContracts(param) {
            this.carregandoTabela = true;
            this.paginacao.page = param;
            const response = await RelatorioRastreabilidadeService.findReportContractsById(this.idRelatorio);
            this.selectedContracts = response.data.contracts;
            this.paginacao.page = response.data.page + 1;
            this.paginacao.totalElements = response.data.totalElements;
            this.paginacao.size = response.data.size;
            this.paginacao.totalPages = response.data.totalPages;
            this.carregandoTabela = false;
        },

        formatData(data) {
            const dataFormatada = new Date(data).toLocaleDateString('pt-BR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
            return dataFormatada;
        },

        verContrato(contract) {
            this.contractId = contract.id;
            this.mostrar = true;
        },

        fecharModalViewContract() {
            this.mostrar = false;
            this.contractId = null;
        }
    }
};
</script>
<style scoped lang="scss">
.report-list-view {
    width: 100%;
    .section-title {
        font-size: 16px;
        line-height: 22px;
        font-weight: 500;
        color: var(--primary-font-color);
    }
    .table-report-list {
        .el-table {
            .cell {
                word-break: break-word !important;
            }

            .action-buttons {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .table-relatorio-rastreabilidade__pagination {
            display: grid;
            grid-template-columns: 2fr auto;
            margin-top: 20px;
            margin-left: 20px;
            padding-bottom: 20px;
            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }

            .total {
                display: flex;
                align-items: center;
                @media (max-width: 768px) {
                    flex-direction: column;
                }
            }

            .prev_next {
                display: flex;
                @media (max-width: 768px) {
                    justify-content: center;
                    margin-top: 20px;
                }
            }
        }
    }
}
</style>
